import { Component, OnInit, AfterViewInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { NavigationEnd, Router } from "@angular/router";
import PerfectScrollbar from "perfect-scrollbar";
import { filter } from "rxjs/operators";
import { AuthService } from "src/app/core/services/auth.service";
import { ChangePasswordComponent } from "src/app/pages/users/change-password/change-password.component";
import swal from "sweetalert2";
declare const $: any;

@Component({
  selector: "app-sidebar-cmp",
  templateUrl: "sidebar.component.html",
  styleUrls: ["sidebar.component.css"],
})
export class SidebarComponent implements OnInit, AfterViewInit {
  menuItems: any[] = [];
  user: any = {};
  expandedMenus: Record<string, boolean> = {};
  private ps: PerfectScrollbar | null = null;

  constructor(
    private auth: AuthService,
    private router: Router,
    private dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.loadUser();
    const { modules } = this.auth.user_data || {};
    this.menuItems = (modules || [])
      .map((item: any) => {
        if (item.children) {
          item.children = item.children.filter((child: any) => child.type === "child");
        }
        return item;
      })
      .sort((a: any, b: any) => a.sort - b.sort);

    this.expandActiveMenus();
    this.initScrollbar();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.loadUser();
        this.expandActiveMenus();
      });
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.loadUser(), 0);
  }

  loadUser(): void {
    this.user = { ...this.auth.getUser(), ...(this.auth.user_data || {}) };
  }

  get displayUserName(): string {
    return (
      this.user?.name ||
      this.user?.username ||
      this.auth.user_data?.name ||
      this.auth.user_data?.username ||
      "User"
    );
  }

  initScrollbar() {
    if (window.matchMedia("(min-width: 960px)").matches && !this.isMac()) {
      const elemSidebar = document.querySelector(
        ".sidebar .sidebar-wrapper",
      ) as HTMLElement | null;
      if (elemSidebar) {
        this.ps = new PerfectScrollbar(elemSidebar);
      }
    }
  }

  updatePS(): void {
    if (this.ps) {
      setTimeout(() => this.ps?.update(), 200);
    }
  }

  menuKey(menuitem: any): string {
    return menuitem.collapse || menuitem.path;
  }

  isExpanded(menuitem: any): boolean {
    return !!this.expandedMenus[this.menuKey(menuitem)];
  }

  toggleSubmenu(menuitem: any): void {
    const key = this.menuKey(menuitem);
    this.expandedMenus[key] = !this.expandedMenus[key];
    this.updatePS();
  }

  childPath(menuitem: any, child: any): string {
    const parentPath = menuitem.path.replace(/\/$/, "");
    const childSegment = child.path.replace(/^\//, "");
    return `${parentPath}/${childSegment}`;
  }

  isParentActive(menuitem: any): boolean {
    if (menuitem.type !== "sub" || !menuitem.children?.length) {
      return false;
    }
    const url = this.router.url.split("?")[0];
    return menuitem.children.some((child: any) => {
      const path = this.childPath(menuitem, child);
      return url === path || url.startsWith(`${path}/`);
    });
  }

  expandActiveMenus(): void {
    for (const menuitem of this.menuItems) {
      if (menuitem.type === "sub" && this.isParentActive(menuitem)) {
        this.expandedMenus[this.menuKey(menuitem)] = true;
      }
    }
  }

  get userInitials(): string {
    const name = this.displayUserName.trim();
    if (!name) {
      return "?";
    }
    const parts = name.split(/\s+/).filter(Boolean);
    if (parts.length === 1) {
      return parts[0].substring(0, 2).toUpperCase();
    }
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  get userRole(): string {
    return this.auth.user_data?.role || this.user?.role || "User";
  }

  isMobileMenu(): boolean {
    return $(window).width() <= 991;
  }

  isMac(): boolean {
    const platform = navigator.platform.toUpperCase();
    return platform.indexOf("MAC") >= 0 || platform.indexOf("IPAD") >= 0;
  }

  logoutAction() {
    swal
      .fire({
        title: "Are you sure?",
        text: "Are you sure to Logout",
        icon: "error",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-secondary",
        },
        confirmButtonText: "Yes, Logout!",
        buttonsStyling: false,
      })
      .then(async (result) => {
        try {
          if (result.value) {
            this.auth.logOut();
            this.router.navigate(["/users/login"]);
          }
        } catch (error) {}
      });
  }

  changePass() {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      width: "500px",
      hasBackdrop: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        this.ngOnInit();
      }
    });
  }
}
